<script>
	import Router from '../States/Router';
	import Twilio from '../States/Twilio';
	import Conference from '../States/Conference';
	import Session from '../States/Session';

	function outputChange(event) {
		const selected = event.currentTarget.value;
		Twilio.setOutputDevice(selected, true);
	}

	function setTestAudio() {
		Twilio.setTestAudio();
	}

	function inputChange(event) {
		const selected = event.currentTarget.value;
		Twilio.setInputDevice(selected, true);
	}

	function pulseIncoming(length) {
		let result = '';
		if (length > 0) result = 'pulse-normal';

		return result;
	}
</script>

<div id="sidebar-container">
	<div class="leftside-menu leftside-menu-detached leftsidemenu">
		<div class="leftbar-user">
			<div id="profile-picture">
				<div class="round-name">{$Session.user.initials}</div>
				<span class="leftbar-user-name">{$Session.user.name}</span>
			</div>
		</div>
	</div>
	<div class="leftside-menu leftside-menu-detached leftsidemenu sidenav">
		<ul class="side-nav">
			<li class="side-nav-title side-nav-item">Navigation</li>
			<li class="side-nav-item">
				<div on:click={(event) => Router.component('dashboard')} class="side-nav-link">
					<i class="uil-home-alt"></i>
					<span> Dashboard </span>
				</div>
			</li>
			<li class="side-nav-item">
				<div on:click={(event) => Router.component('contact_list')} class="side-nav-link">
					<i class="uil-users-alt"></i>
					<span> Contacts </span>
				</div>
			</li>
			{#if $Conference.call.active}
				<li class="side-nav-item">
					<div on:click={(event) => Router.component('conference')} class="side-nav-link">
						<i class="uil-phone"></i>
						<span class="badge bg-danger float-end">Live</span>
						<span> Conference </span>
					</div>
				</li>
			{/if}
			<li class="side-nav-item">
				<div on:click={(event) => Router.component('conference_list')} class="side-nav-link">
					<i class="uil-phone"></i>
					<span class="badge bg-primary rounded-pill float-end">{$Conference.list.active.length + $Conference.list.incoming.length}</span>
					{#if $Conference.list.incoming.length}
						<span class="badge bg-danger float-end incoming-badge {pulseIncoming($Conference.list.incoming.length)}">incoming</span>
					{/if}
					<span> Conferences </span>
				</div>
			</li>
			<!-- <li class="side-nav-item">
                <a href="settings.html" class="side-nav-link">
                    <i class="dripicons-gear"></i>
                    <span> Settings </span>
                </a>
            </li> -->
		</ul>
		<div class="clearfix"></div>
	</div>
	<div id="audio-settings" class="card d-lg-block d-none">
		<div class="card-body">
			<h4 class="header-title mb-3">Audio Settings</h4>
			<div>
				<h5>Input</h5>
				<ul class="list-group">
					{#each $Twilio.audioDevices.input as item}
						<li class="list-group-item">
							<input class="form-check-input me-1" name="audio_input" type="radio" value={item.id} on:change={inputChange} bind:group={$Twilio.currentDevice.input} />
							<span title={item.name}>{item.name}</span>
						</li>
					{/each}
				</ul>
			</div>

			<div class="mt-3">
				<h5>Output <button class="btn btn-success btn-sm ms-2" on:click={setTestAudio}>Test</button></h5>
				<ul class="list-group">
					{#each $Twilio.audioDevices.output as item}
						<li class="list-group-item">
							<input class="form-check-input me-1" name="audio_output" type="radio" value={item.id} on:change={outputChange} bind:group={$Twilio.currentDevice.output} />
							<span title={item.name}>{item.name}</span>
						</li>
					{/each}
				</ul>
			</div>
		</div>
	</div>
</div>

<style>
	#profile-picture {
		display: grid;
		justify-content: center;
		align-items: center;
	}

	#profile-picture .round-name {
		width: 50px;
		height: 50px;
		font-size: 1.5em;
		justify-self: center;
	}

	.side-nav-link {
		cursor: pointer;
	}

	.leftsidemenu {
		border-radius: 0.25rem;
		box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%);
	}

	.leftbar-user-name {
		margin-left: 0 !important;
	}

	#audio-settings {
		overflow-y: scroll;
		height: 50vh;
	}

	.list-group-item {
		white-space: nowrap;
		overflow: hidden !important;
		text-overflow: ellipsis;
		max-width: 200px;
	}

	#sidebar-container {
		height: 100%;
	}

	.side-nav {
		padding-bottom: 1em;
	}

	.incoming-badge {
		margin-right: 0.3em;
	}
	.leftsidemenu.sidenav {
		margin-top: 1rem;
	}
</style>
